import React from 'react';
import '../Section10/component.css';

const Section19 = () => {
  return (
    <div className="svc-intro" style={{ paddingTop: '0px', borderBottom: 'none' }}>
      <div className="svc-intro-inner">
        <div className="svc-details">
          <h3 className="svc-intro-title">Why Choose Hypertonic</h3>

          <div className="svc-feature">
            <h4>Expertise</h4>
            <p className="svc-intro-body">With years of experience, our team possesses the technical skills and domain knowledge to tackle even the most complex software development projects from web apps to enterprise solutions.</p>
          </div>

          <div className="svc-feature">
            <h4>Custom Solutions</h4>
            <p className="svc-intro-body">We believe in creating bespoke software solutions that address the unique needs and challenges of each client tailored to specific business goals and objectives.</p>
          </div>

          <div className="svc-feature">
            <h4>Cutting-Edge Tech</h4>
            <p className="svc-intro-body">From cloud-based architectures to AI and machine learning, we fully leverage cutting-edge technologies to develop software solutions that are scalable, innovative and future-proof.</p>
          </div>

          <div className="svc-feature">
            <h4>Agile Methodology</h4>
            <p className="svc-intro-body">We follow agile software development methodologies. By breaking down projects into smaller tasks and iterating quickly, we reliably deliver high-quality solutions efficiently.</p>
          </div>

          <div className="svc-feature">
            <h4>24*7 Service</h4>
            <p className="svc-intro-body">Our committed team is available 24 hours a day, 7 days a week, standing ready to help when you need assistance most.</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Section19;
